'use client';

import type { ElasticVehicle } from '@//app/api/search/vehicles/[id]';
import SchemaCar from '@//containers/StructuredData/SchemaCar';

interface VehicleStructuredDataProps {
  vehicle: ElasticVehicle;
}

export const VehicleStructuredData: React.FC<VehicleStructuredDataProps> = ({ vehicle }) => (
  <SchemaCar
    name={vehicle.title}
    vehicleIdentificationNumber={vehicle.vinNumber}
    image={vehicle.media?.map((m) => m.files[0]?.url)}
    url={`${process.env.NEXT_PUBLIC_BASE_URL}/item/${vehicle.id}`}
    price={vehicle.price}
    priceCurrency="SEK"
    mileageFromOdometerValue={vehicle.mileage ?? 0} // Maby use odometerValue instead?
    brandName={vehicle.manufacturer}
    model={vehicle.modelName}
    vehicleConfiguration={vehicle.modelSeries}
    vehicleModelDate={vehicle.modelYear.toString()}
    color={vehicle.properties?.colorName}
    bodyType={vehicle.vehicleType}
    driveWheelConfiguration={
      vehicle.properties?.drivingWheel === 'FWD'
        ? 'FrontWheelDriveConfiguration'
        : vehicle.properties?.drivingWheel === 'RWD'
          ? 'RearWheelDriveConfiguration'
          : vehicle.properties?.drivingWheel === 'AWD'
            ? 'AllWheelDriveConfiguration'
            : 'FourWheelDriveConfiguration'
    }
    fuelType={vehicle.fuelType}
    vehicleTransmission={vehicle.gearbox}
    numberOfDoors={vehicle.properties?.numberOfDoors}
    vehicleSeatingCapacity={vehicle.properties?.seats}
  />
);
